import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'sync' } )
export class SyncPipe implements PipeTransform {

    transform( pIsSynced: boolean ): string {
        if ( pIsSynced != null ) {
            return pIsSynced === true ? 'Synced' : 'Not Synced';
        }
        return null;
    }
}